'use strict';

const observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function MapMetadataModel(pageController, navigatorShim, optional) {
	if (!pageController || !navigatorShim) {
		throw 'invalid-args';
	}
	let currentName = false;
	const self = observable(this),
		setCurrentName = function (newName) {
			if (currentName !== newName) {
				navigatorShim.setTitle(newName);
				self.dispatchEvent('mapNameChanged', newName);
			}
			currentName = newName;
		};

	pageController.addEventListener('fileLoaded', (fileId, name) => setCurrentName(name));
	pageController.addEventListener('renamed', setCurrentName);

	if (optional && optional.metadataSynchronizer) {
		optional.metadataSynchronizer.addEventListener('title', setCurrentName);
	}

	self.getCurrentName = () => currentName;
};
